import type { FunctionComponent } from 'react';

export const KyckrIcon: FunctionComponent<{ className?: string }> = ({ className }) => {
  return (
    <img
      src="https://cdn.ballerine.io/merch-ss/decoded_image.png"
      alt="Kyckr"
      className={className}
    />
  );
};
